<template>
  <v-card>
    <v-card-title>
      <span class="section-title">{{ cardTitle }}</span>
      <v-spacer />
    </v-card-title>
    <v-card-text class="logs-content pb-3">
      <v-row>
        <v-col cols="3" class="pb-1 pt-0 info-text">Usuário:</v-col>
        <v-col cols="9" class="pb-1 pt-0 info-text info-text__bold">{{ log.user.login }}</v-col>
        <v-col cols="3" class="pb-1 pt-0 info-text">Data e hora:</v-col>
        <v-col cols="9" class="pb-1 pt-0 info-text info-text__bold">{{ formatDate(log.created_at) }}</v-col>
        <v-col cols="12" class="pb-0 pt-5">
          <h3 class="empashis-title">Alterações:</h3>
        </v-col>
        <mf-loading :boolean-loader="loading">
          <v-col cols="12" class="py-0">
            <div v-if="arrayDelta.length === 0" class="emphasis-box mt-3 text-center">Sem alterações</div>
            <div v-for="(descriptions, index) in arrayDelta" :key="index" class="emphasis-box mb-5">
              <v-row class="mb-2">
                <v-col cols="12" class="py-0">
                  <div>
                    <span class="texto-corrido">
                      {{ descriptions.description || descriptions.field }}
                    </span>
                    <v-badge color="#E03210" content="Antigo" inline />
                  </div>
                </v-col>
                <v-col cols="12" class="py-0">
                  <vue-json-pretty v-if="descriptions.isOldAnObject" :data="descriptions.formattedOld" :deep="1" highlight-mouseover-node show-line />
                  <span v-else> {{ descriptions.formattedOld }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <div>
                    <span class="texto-corrido">
                      {{ descriptions.description || descriptions.field }}
                    </span>
                    <v-badge color="#00B395" content="Novo" inline />
                  </div>
                </v-col>
                <v-col cols="12" class="py-0">
                  <vue-json-pretty v-if="descriptions.isNewAnObject" :data="descriptions.formattedNew" :deep="1" highlight-mouseover-node show-line />
                  <span v-else> {{ descriptions.formattedNew }}</span>
                </v-col>
              </v-row>
              <v-row v-if="descriptions.isNewAnObject" class="mt-2">
                <v-col cols="12" class="py-0">
                  <div>
                    <span class="texto-corrido"> Comparação das alterações </span>
                  </div>
                </v-col>
                <v-col cols="12" class="py-0">
                  <vue-json-compare :oldData="descriptions.formattedOld" :newData="descriptions.formattedNew"></vue-json-compare>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </mf-loading>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <mf-action-buttons
        class="mr-2 py-2"
        :primary-button="{
          text: 'Voltar',
          action: backButtonClick,
          isVisible: true,
        }"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import vueJsonCompare from 'vue-json-compare'
import { utilsMixin } from './mixins/utils'
import { QUERY_LOG_BY_ID } from './graphql'

export default {
  name: 'LogDetails',
  components: {
    VueJsonPretty,
    vueJsonCompare,
  },
  mixins: [utilsMixin],
  props: {
    log: {
      type: Object,
      required: true,
    },
    cardTitle: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    logDetails: {},
    loading: false,
  }),
  computed: {
    arrayDelta() {
      const delta = Array.isArray(this.logDetails.delta) ? this.logDetails.delta : []
      delta.forEach((deltaElement) => {
        deltaElement.formattedNew = this.assertFormat(deltaElement.new)
        deltaElement.isNewAnObject = typeof deltaElement.formattedNew === 'object'
        deltaElement.formattedOld = this.assertFormat(deltaElement.old)
        deltaElement.isOldAnObject = typeof deltaElement.formattedOld === 'object'
      })
      return delta
    },
  },
  mounted() {
    this.getLogsData()
  },
  methods: {
    backButtonClick() {
      this.$emit('back-button-click')
    },
    getLogsData() {
      this.loading = true
      this.$apollo
        .query({
          query: QUERY_LOG_BY_ID,
          variables: {
            _id: this.log._id,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data: { operationLogById } }) => {
          this.loading = false
          this.logDetails = operationLogById
        })
        .catch((error) => {
          console.error(error)
          this.loading = false
          this.$snackbar({ message: 'Erro ao buscar dados.' })
        })
    },
  },
}
</script>

<style lang="scss">
.info-text {
  font-size: 16px;
  color: $cinza-0;
  &__bold {
    font-weight: 700;
  }
}
.empashis-title {
  font-size: 18px;
  color: $cinza-d10;
}
.emphasis-box {
  background-color: $cinza-l90;
  border-radius: 5px;
  padding: 15px;
}
.link {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $marca-0-l40 !important;
  text-transform: none;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}

.logs-content {
  p {
    margin-bottom: 0 !important;
  }
  .c-json-outter {
    margin-top: -30px;
    margin-bottom: -30px !important;
  }
}
</style>
